import React, { useState } from 'react';
import InputMask from 'react-input-mask';
import IntlTelInput from 'react-intl-tel-input';

import 'react-intl-tel-input/dist/main.css';

const InputWithCountrySelect = ({ setPhone, placeholder }) => {
    const [country, setCountry] = useState({ prefix: 'ru', dialCode: '7' });
    const [value, setValue] = useState('');

    const maskValue = () => {
        if (country.prefix === 'kz') return '(799) 999-99-99';
        else if (country.prefix === 'ru') return '(\\999) 999-99-99';
        else if (country.prefix === 'by') return '(99) 999-99-99';
    };

    const onChange = e => {
        setValue(e.target.value);
        setPhone(country.dialCode + e.target.value);
    };

    const onInputChange = (status, country) => {
        setValue('');
        setCountry({ prefix: country.iso2, dialCode: country.dialCode });
    };

    return (
        <div style={{ position: 'relative', marginBottom: '20px' }}>
            <InputMask
                className="login-form__input masked-input"
                placeholder={placeholder}
                mask={maskValue()}
                required={!!value}
                disabled={false}
                alwaysShowMask={true}
                value={value}
                onChange={onChange}
            />

            <IntlTelInput
                onSelectFlag={onInputChange}
                containerClassName="intl-tel-input"
                inputClassName="login-form__input_hidden"
                onlyCountries={['ru', 'by', 'kz']}
                preferredCountries={false}
                separateDialCode={true}
                defaultCountry="ru"
                required
            />
        </div>
    );
};

export default InputWithCountrySelect;
